
import { Component, Prop, Vue } from 'vue-facing-decorator'
import ChangePrice from './change-price.vue'
import ChangeStock from './change-stock.vue'

@Component({
  components: { ChangePrice, ChangeStock }
})
export default class extends Vue {
  /** 列表行，只用它的 id 去拉详情：价格/库存以外层表格为准可能已经过期 */
  @Prop()
  modelValue: any

  /** 外层 popover 的收起方法，改完用它关掉整个 popover */
  @Prop()
  hideEvent: any

  formData: any = {}
  loading = false;
  /** '' 列表态 | 'price' | 'stock' */
  editing = '';
  editingRow: any = {};

  created() {
    this.getData();
  }

  edit(row, type) {
    this.editingRow = row;
    this.editing = type;
  }

  successEvent() {
    this.editing = '';
    /** 外层的价格/库存列也要跟着变 */
    this.$emit('refresh');
    this.getData();
  }

  async getData() {
    this.loading = true;
    let { error, data } = await this.$post('/manager/goods/detail', {
      id: this.modelValue.id,
    });
    this.loading = false;
    if (error) return;
    this.formData = data || {};
  }

  get skuRows() {
    let list = this.formData.skuList || [];
    let names = this.specNameList;
    return list.map((item, index) => {
      return { ...item, index, name: names[index] || '' };
    });
  }

  /**
   * 规格值的笛卡尔积，顺序必须和编辑页 computSku 一致：
   * 保存时后端按数组下标写 sort（goods.controller.ts 的 skuList.map((item, i) => sort: i)），
   * 读取时实体再按 sort 排序，所以 skuList[i] 就是第 i 个规格组合，按配下标就能对上名字
   */
  get specNameList() {
    let spec = this.formData.spec;
    let specs = (Array.isArray(spec) ? spec : (spec ? [spec] : [])).filter((item) => {
      return item.specList && item.specList.length;
    });
    if (!specs.length) return [];
    let res = [''];
    specs.forEach((item) => {
      let next = [];
      res.forEach((prefix) => {
        item.specList.forEach((value) => {
          next.push(prefix ? `${prefix} / ${value.name}` : value.name);
        });
      });
      res = next;
    });
    return res;
  }
}
